import { createReducer } from 'redux-act';

import * as actions from '#app/actions/contract';

export interface ContractState {
  modalVisible: boolean;
  form: Record<string, unknown>;
  smsConfirmModalVisible: boolean;
  smsConfirmForm: Record<string, unknown>;
  strategyRulesModalVisible: boolean;
  strategyRulesForm: Record<string, unknown>;
  brokerSelectModalVisible: boolean;
  brokerSelectForm: Record<string, unknown>;
  brokerConnectionModalVisible: boolean;
  brokerConnectionForm: Record<string, unknown>;
  accountSelectModalVisible: boolean;
  accountSelectForm: Record<string, unknown>;
  brokerConnectionStatusModalVisible: boolean;
  brokerConnectionStatusForm: Record<string, unknown>;
  confirmSaleModalVisible: boolean;
  confirmSaleForm: Record<string, unknown>;
  brokerConnectionSuccessModalVisible: boolean;
  brokerConnectionSuccessForm: Record<string, unknown>;
  roboGoalModalVisible: boolean;
  roboGoalForm: Record<string, unknown>;
  roboReadyModalVisible: boolean;
  roboReadyForm: Record<string, unknown>;
  roboadvisorWizardModalVisible: boolean;
  roboadvisorWizardForm: Record<string, unknown>;
  roboadvisorWithdrawModalVisible: boolean;
  roboadvisorWithdrawForm: Record<string, unknown>;
  roboadvisorWithdrawSuccessModalVisible: boolean;
  roboadvisorWithdrawSuccessForm: Record<string, unknown>;
  roboadvisorDisconnectModalVisible: boolean;
  roboadvisorDisconnectForm: Record<string, unknown>;
  roboadvisorNotificationModalVisible: boolean;
  roboadvisorNotificationForm: Record<string, unknown>;
  chatModalVisible: boolean;
  chatForm: Record<string, unknown>;
}

const contract: ContractState = {
  modalVisible: false,
  form: {},
  smsConfirmModalVisible: false,
  smsConfirmForm: {},
  strategyRulesModalVisible: false,
  strategyRulesForm: {},
  brokerSelectModalVisible: false,
  brokerSelectForm: {},
  brokerConnectionModalVisible: false,
  brokerConnectionForm: {},
  accountSelectModalVisible: false,
  accountSelectForm: {},
  brokerConnectionStatusModalVisible: false,
  brokerConnectionStatusForm: {},
  confirmSaleModalVisible: false,
  confirmSaleForm: {},
  brokerConnectionSuccessModalVisible: false,
  brokerConnectionSuccessForm: {},
  roboGoalModalVisible: false,
  roboGoalForm: {},
  roboReadyModalVisible: false,
  roboReadyForm: {},
  roboadvisorWizardModalVisible: false,
  roboadvisorWizardForm: {},
  roboadvisorWithdrawModalVisible: false,
  roboadvisorWithdrawForm: {},
  roboadvisorWithdrawSuccessModalVisible: false,
  roboadvisorWithdrawSuccessForm: {},
  roboadvisorDisconnectModalVisible: false,
  roboadvisorDisconnectForm: {},
  roboadvisorNotificationModalVisible: false,
  roboadvisorNotificationForm: {},
  chatModalVisible: false,
  chatForm: {},
};

const setContractModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    modalVisible: bool,
  };
};

const closeContractForm = (state: ContractState) => {
  return {
    ...state,
    form: {},
    modalVisible: false,
  };
};

const setContractForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    form: form,
    modalVisible: true,
  };
};

const setSmsConfirmModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    smsConfirmModalVisible: bool,
  };
};

const closeSmsConfirmForm = (state: ContractState) => {
  return {
    ...state,
    smsConfirmForm: {},
    smsConfirmModalVisible: false,
  };
};

const setSmsConfirmForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    smsConfirmForm: form,
    smsConfirmModalVisible: true,
  };
};

const setStrategyRulesModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    strategyRulesModalVisible: bool,
  };
};

const closeStrategyRulesForm = (state: ContractState) => {
  return {
    ...state,
    strategyRulesForm: {},
    strategyRulesModalVisible: false,
  };
};

const setStrategyRulesForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    strategyRulesForm: form,
    strategyRulesModalVisible: true,
  };
};

const setBrokerSelectModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    brokerSelectModalVisible: bool,
  };
};

const closeBrokerSelectForm = (state: ContractState) => {
  return {
    ...state,
    brokerSelectForm: {},
    brokerSelectModalVisible: false,
  };
};

const setBrokerSelectForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    brokerSelectForm: form,
    brokerSelectModalVisible: true,
  };
};

const setBrokerConnectionModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    brokerConnectionModalVisible: bool,
  };
};

const closeBrokerConnectionForm = (state: ContractState) => {
  return {
    ...state,
    brokerConnectionForm: {},
    brokerConnectionModalVisible: false,
  };
};

const setBrokerConnectionForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    brokerConnectionForm: form,
    brokerConnectionModalVisible: true,
  };
};

const setAccountSelectModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    accountSelectModalVisible: bool,
  };
};

const closeAccountSelectForm = (state: ContractState) => {
  return {
    ...state,
    accountSelectForm: {},
    accountSelectModalVisible: false,
  };
};

const setAccountSelectForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    accountSelectForm: form,
    accountSelectModalVisible: true,
  };
};

const setBrokerConnectionStatusModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    brokerConnectionStatusModalVisible: bool,
  };
};

const closeBrokerConnectionStatusForm = (state: ContractState) => {
  return {
    ...state,
    brokerConnectionStatusForm: {},
    brokerConnectionStatusModalVisible: false,
  };
};

const setBrokerConnectionStatusForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    brokerConnectionStatusForm: form,
    brokerConnectionStatusModalVisible: true,
  };
};

const setConfirmSaleModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    confirmSaleModalVisible: bool,
  };
};

const closeConfirmSaleForm = (state: ContractState) => {
  return {
    ...state,
    confirmSaleForm: {},
    confirmSaleModalVisible: false,
  };
};

const setConfirmSaleForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    confirmSaleForm: form,
    confirmSaleModalVisible: true,
  };
};

const setBrokerConnectionSuccessModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    brokerConnectionSuccessModalVisible: bool,
  };
};

const closeBrokerConnectionSuccessForm = (state: ContractState) => {
  return {
    ...state,
    brokerConnectionSuccessForm: {},
    brokerConnectionSuccessModalVisible: false,
  };
};

const setBrokerConnectionSuccessForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    brokerConnectionSuccessForm: form,
    brokerConnectionSuccessModalVisible: true,
  };
};

const setRoboGoalModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    roboGoalModalVisible: bool,
  };
};

const closeRoboGoalForm = (state: ContractState) => {
  return {
    ...state,
    roboGoalForm: {},
    roboGoalModalVisible: false,
  };
};

const setRoboGoalForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    roboGoalForm: form,
    roboGoalModalVisible: true,
  };
};

const setRoboReadyModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    roboReadyModalVisible: bool,
  };
};

const closeRoboReadyForm = (state: ContractState) => {
  return {
    ...state,
    roboReadyForm: {},
    roboReadyModalVisible: false,
  };
};

const setRoboReadyForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    roboReadyForm: form,
    roboReadyModalVisible: true,
  };
};

const setRoboadvisorWizardModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    roboadvisorWizardModalVisible: bool,
  };
};

const closeRoboadvisorWizard = (state: ContractState) => {
  return {
    ...state,
    roboadvisorWizardForm: {},
    roboadvisorWizardModalVisible: false,
  };
};

const setRoboadvisorWizardForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    roboadvisorWizardForm: form,
    roboadvisorWizardModalVisible: true,
  };
};

const setRoboadvisorWithdrawModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    roboadvisorWithdrawModalVisible: bool,
  };
};

const closeRoboadvisorWithdraw = (state: ContractState) => {
  return {
    ...state,
    roboadvisorWithdrawForm: {},
    roboadvisorWithdrawModalVisible: false,
  };
};

const setRoboadvisorWithdrawForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    roboadvisorWithdrawForm: form,
    roboadvisorWithdrawModalVisible: true,
  };
};

const setRoboadvisorWithdrawSuccessModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    roboadvisorWithdrawSuccessModalVisible: bool,
  };
};

const closeRoboadvisorWithdrawSuccess = (state: ContractState) => {
  return {
    ...state,
    roboadvisorWithdrawSuccessForm: {},
    roboadvisorWithdrawSuccessModalVisible: false,
  };
};

const setRoboadvisorWithdrawSuccessForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    roboadvisorWithdrawSuccessForm: form,
    roboadvisorWithdrawSuccessModalVisible: true,
  };
};

// Roboadvisor Disconnect Modal reducers (unified modal with steps)
const setRoboadvisorDisconnectModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    roboadvisorDisconnectModalVisible: bool,
  };
};

const closeRoboadvisorDisconnect = (state: ContractState) => {
  return {
    ...state,
    roboadvisorDisconnectForm: {},
    roboadvisorDisconnectModalVisible: false,
  };
};

const setRoboadvisorDisconnectForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    roboadvisorDisconnectForm: form,
    roboadvisorDisconnectModalVisible: true,
  };
};

// Roboadvisor Notification Detail Modal reducers
const setRoboadvisorNotificationModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    roboadvisorNotificationModalVisible: bool,
  };
};

const closeRoboadvisorNotification = (state: ContractState) => {
  return {
    ...state,
    roboadvisorNotificationForm: {},
    roboadvisorNotificationModalVisible: false,
  };
};

const setRoboadvisorNotificationForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    roboadvisorNotificationForm: form,
    roboadvisorNotificationModalVisible: true,
  };
};

// Chat modal reducers
const setChatModalVisible = (state: ContractState, bool: boolean) => {
  return {
    ...state,
    chatModalVisible: bool,
  };
};

const closeChatModal = (state: ContractState) => {
  return {
    ...state,
    chatForm: {},
    chatModalVisible: false,
  };
};

const setChatModalForm = (state: ContractState, form: Record<string, unknown>) => {
  return {
    ...state,
    chatForm: form,
    chatModalVisible: true,
  };
};

const reducer = createReducer<ContractState>(
  {
    [actions.setContractModalVisible as any]: setContractModalVisible,
    [actions.setContractForm as any]: setContractForm,
    [actions.closeContractForm as any]: closeContractForm,
    [actions.setSmsConfirmModalVisible as any]: setSmsConfirmModalVisible,
    [actions.setSmsConfirmForm as any]: setSmsConfirmForm,
    [actions.closeSmsConfirmForm as any]: closeSmsConfirmForm,
    [actions.setStrategyRulesModalVisible as any]: setStrategyRulesModalVisible,
    [actions.setStrategyRulesForm as any]: setStrategyRulesForm,
    [actions.closeStrategyRulesForm as any]: closeStrategyRulesForm,
    [actions.setBrokerSelectModalVisible as any]: setBrokerSelectModalVisible,
    [actions.setBrokerSelectForm as any]: setBrokerSelectForm,
    [actions.closeBrokerSelectForm as any]: closeBrokerSelectForm,
    [actions.setBrokerConnectionModalVisible as any]: setBrokerConnectionModalVisible,
    [actions.setBrokerConnectionForm as any]: setBrokerConnectionForm,
    [actions.closeBrokerConnectionForm as any]: closeBrokerConnectionForm,
    [actions.setAccountSelectModalVisible as any]: setAccountSelectModalVisible,
    [actions.setAccountSelectForm as any]: setAccountSelectForm,
    [actions.closeAccountSelectForm as any]: closeAccountSelectForm,
    [actions.setBrokerConnectionStatusModalVisible as any]: setBrokerConnectionStatusModalVisible,
    [actions.setBrokerConnectionStatusForm as any]: setBrokerConnectionStatusForm,
    [actions.closeBrokerConnectionStatusForm as any]: closeBrokerConnectionStatusForm,
    [actions.setConfirmSaleModalVisible as any]: setConfirmSaleModalVisible,
    [actions.setConfirmSaleForm as any]: setConfirmSaleForm,
    [actions.closeConfirmSaleForm as any]: closeConfirmSaleForm,
    [actions.setBrokerConnectionSuccessModalVisible as any]: setBrokerConnectionSuccessModalVisible,
    [actions.setBrokerConnectionSuccessForm as any]: setBrokerConnectionSuccessForm,
    [actions.closeBrokerConnectionSuccessForm as any]: closeBrokerConnectionSuccessForm,
    [actions.setRoboGoalModalVisible as any]: setRoboGoalModalVisible,
    [actions.setRoboGoalForm as any]: setRoboGoalForm,
    [actions.closeRoboGoalForm as any]: closeRoboGoalForm,
    [actions.setRoboReadyModalVisible as any]: setRoboReadyModalVisible,
    [actions.setRoboReadyForm as any]: setRoboReadyForm,
    [actions.closeRoboReadyForm as any]: closeRoboReadyForm,
    [actions.setRoboadvisorWizardModalVisible as any]: setRoboadvisorWizardModalVisible,
    [actions.setRoboadvisorWizardForm as any]: setRoboadvisorWizardForm,
    [actions.closeRoboadvisorWizard as any]: closeRoboadvisorWizard,
    [actions.setRoboadvisorWithdrawModalVisible as any]: setRoboadvisorWithdrawModalVisible,
    [actions.setRoboadvisorWithdrawForm as any]: setRoboadvisorWithdrawForm,
    [actions.closeRoboadvisorWithdraw as any]: closeRoboadvisorWithdraw,
    [actions.setRoboadvisorWithdrawSuccessModalVisible as any]:
      setRoboadvisorWithdrawSuccessModalVisible,
    [actions.setRoboadvisorWithdrawSuccessForm as any]: setRoboadvisorWithdrawSuccessForm,
    [actions.closeRoboadvisorWithdrawSuccess as any]: closeRoboadvisorWithdrawSuccess,
    [actions.setRoboadvisorDisconnectModalVisible as any]: setRoboadvisorDisconnectModalVisible,
    [actions.setRoboadvisorDisconnectForm as any]: setRoboadvisorDisconnectForm,
    [actions.closeRoboadvisorDisconnect as any]: closeRoboadvisorDisconnect,
    [actions.setRoboadvisorNotificationModalVisible as any]: setRoboadvisorNotificationModalVisible,
    [actions.setRoboadvisorNotificationForm as any]: setRoboadvisorNotificationForm,
    [actions.closeRoboadvisorNotification as any]: closeRoboadvisorNotification,
    [actions.setChatModalVisible as any]: setChatModalVisible,
    [actions.setChatModalForm as any]: setChatModalForm,
    [actions.closeChatModal as any]: closeChatModal,
  },
  contract
);

export default reducer;
